import axios from "axios";

/**
 * ZoomService handles the Zoom API requests, including adding participants to a meeting.
 */
class ZoomService {
  constructor(access_token) {
    if (!access_token) {
      throw new Error("Zoom access token is required");
    }
    this.token = access_token;
    this.baseUrl = "https://api.zoom.us/v2";
  }
}

export const isZoomTokenValid = (expires_in) => {
  console.log("isZoomTokenValid expires_in:,", expires_in);
  if (!expires_in) return false;
  return Date.now() < expires_in;
};

/**
 * Encodes a string to Base64 format in a browser-compatible way.
 * @param {string} str - The string to encode.
 * @returns {string} The Base64 encoded string.
 */
export const toBase64 = (str) => {
  return window.btoa(unescape(encodeURIComponent(str)));
};

export const assignMeetingId = (category, sabbathGroup) => {
  let meetingId = null;
  console.log("assignMeetingId category:", category);
  console.log("assignMeetingId sabbathGroup:", sabbathGroup);
  // Mapping logic based on category and user type (US/UK and Adult/Youth)
  if (sabbathGroup === "US") {
    if (category === "Adult") {
      meetingId = process.env.REACT_APP_ZOOM_MEETING_ID_USGA;
    } else if (category === "Youth") {
      meetingId = process.env.REACT_APP_ZOOM_MEETING_ID_USYGA;
    }
    else if (category === "Online Retreat") {
      meetingId = process.env.REACT_APP_ZOOM_MEETING_ID_USRETREAT;
    }
    else if (category === "MarianSpiritualWarfare") {
      meetingId = process.env.REACT_APP_ZOOM_MEETING_ID_MARIANSW;
    } else if (category === "MarianConsecration") {
      meetingId = process.env.REACT_APP_ZOOM_MEETING_ID_MARIANCON;
    }
  } else if (sabbathGroup === "UK") {
    if (category === "Adult") {
      meetingId = null;
    } else if (category === "Youth") {
      meetingId = null;
    }
  }
  return meetingId;
};

/**
 * Fetches the participants of a Zoom meeting.
 * @param {string} meetingId - The ID of the Zoom meeting.
 * @param {string} accessToken - The access token for Zoom API.
 * @returns {Promise<Object>} The list of participants.
 */

export const fetchZoomParticipants = async (meetingId, accessToken) => {
  console.log("fetchZoomParticipants meetingId:", meetingId);
  if (!meetingId) {
    throw new Error("Meeting ID is required to fetch participants");
  }
  if (!accessToken) {
    throw new Error("Access token is required to fetch participants");
  }
  
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/fetch-zoom-participants`,
      {
        params: {  // Query parameters
          meetingId,
          accessToken
        }
      }
    );
    //console.log("Zoom participants response:", response.data);
    
    return response?.data;
  } catch (error) {
    console.error("Error fetching participants:", error);
    throw error;
  }
};

/**
 * Fetches attendance for a meeting on a specific date.
 * @param {string} meetingId - The Zoom meeting ID.
 * @param {string} date - The date in YYYY-MM-DD format.
 * @param {string} accessToken - The Zoom access token.
 * @returns {Promise<Object[]>} The attendance details.
 */
export const fetchZoomAttendance = async (meetingId, date, accessToken) => {
  console.log("fetchZoomAttendance meetingId:", meetingId);
  console.log("fetchZoomAttendance date:", date);
  if (!meetingId) {
    throw new Error("Meeting ID is required to fetch attendance");
  }
  if (!accessToken) {
    throw new Error("Access token is required to fetch attendance");
  }

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/fetch-zoom-attendance`,
      {
        params: {
          meetingId,
          date,
        },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response?.data;
  } catch (error) {
    console.error("Error fetching attendance:", error);
    throw error;
  }
};

/**
 * Get Zoom access token using authorization code.
 * @param {string} authorizationCode - The authorization code received from Zoom.
 * @param {Function} setZoomToken - Function to store the new Zoom token in the Auth context.
 * @returns {string} The access token.
 */
export const getZoomAccessToken = async (
  authorizationCode,
  refresh_token,
  setZoomToken
) => {

  const clientSecret = process.env.REACT_APP_ZOOM_CLIENT_SECRET;
  const clientId = process.env.REACT_APP_ZOOM_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_ZOOM_REDIRECT_URI; // Append /callback to the redirect URI

  const tokenEndpoint = "https://zoom.us/oauth/token";
  console.log("Client ID:", clientId);
  console.log("Client Secret:", clientSecret);
  console.log("Redirect URI:", redirectUri);
  console.log("Redirect authorizationCode:", authorizationCode);
  console.log("Redirect refresh_token:", refresh_token);
  const authHeader = toBase64(`${clientId}:${clientSecret}`);

  console.log("getZoomAccessToken authorizationCode :", authorizationCode);
  console.log("getZoomAccessToken  refresh_token :", refresh_token);
  console.log("authHeader:", authHeader);
  try {
    console.log("Try :", authHeader);

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/zoom/oauth/token`,
      {
        code: authorizationCode,
        refresh_token: refresh_token,
        redirectUri: process.env.REACT_APP_ZOOM_REDIRECT_URI,
      }
    );
    console.log("Zoom Access response:", response);
    // Log response and store the token
    console.log("Zoom Access Token response:", response.data);

    /*Call the function to update the zoom token in Auth context
    setZoomToken(
      response.data.access_token,
      response.data.refresh_token,
      response.data.expires_in
    );*/

    return response.data;
  } catch (error) {
    console.error("Error getting access token:", error);
    console.error("Error getting access token:", error.response?.data);
    throw error;
  }
};

export default ZoomService;
